"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const react_scroll_1 = require("react-scroll");
const pattern_library_components_modal_1 = require("@saatva-bits/pattern-library.components.modal");
const ProductLabel_module_scss_1 = __importDefault(require("./ProductLabel.module.scss"));
const floatingProductPanelOffset = -95;
/**
 *
 * @param {string} label
 * @param {boolean} isCustomLabel
 * @returns {string}
 */
const getLabel = (label, isCustomLabel) => {
    if (isCustomLabel) {
        return label;
    }
    const lowerCaseLabel = label.toLowerCase();
    if (lowerCaseLabel.includes('size')) {
        return 'Select size';
    }
    if (lowerCaseLabel.includes('pillow')) {
        return 'Select pillow height';
    }
    return `Select ${label}`;
};
/**
 *
 * @param {Object} props
 * @param {string} props.className
 * @param {string} props.text
 * @param {string} props.header
 * @param {import('react').ReactNode} props.content
 * @param {Object.<string, string>} props.contentProps
 * @param {function} props.onClick
 * @returns
 */
const ModalToggle = ({ className, text, header, content, contentProps, onClick }) => {
    const [isModalVisible, setIsModalVisible] = (0, react_1.useState)(false);
    const Content = content;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: className, onClick: (e) => {
                    setIsModalVisible(true);
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
                }, children: text }), isModalVisible &&
                (0, jsx_runtime_1.jsx)(pattern_library_components_modal_1.Modal, { isModalVisible: isModalVisible, modalTitle: header, titleClassName: 't-color', onModalClose: () => {
                        setIsModalVisible(false);
                    }, children: (0, jsx_runtime_1.jsx)(Content, { ...contentProps }) })] }));
};
ModalToggle.propTypes = {
    className: prop_types_1.default.string,
    text: prop_types_1.default.string,
    header: prop_types_1.default.string,
    content: prop_types_1.default.node,
    contentProps: prop_types_1.default.object,
    onClick: prop_types_1.default.func
};
/**
 *
 * @param {Object} props
 * @param {string} props.className
 * @param {string} props.swatchLabel
 * @param {number} props.index
 * @param {boolean} props.isCheckbox
 * @param {boolean} props.isCustomLabel
 * @param {boolean} props.hideSize
 * @param {boolean} props.hideQuantity
 * @param {boolean} props.showSurplusSaleLabel
 * @param {('modal' | 'link' | 'anchor')} props.toggleType
 * @param {string} props.toggleLabel
 * @param {any} props.toggleContent
 * @param {function} props.toggleClickHandler
 * @param {string} props.toggleModalHeader
 * @param {Object.<string, string>} props.modalContentProps
 * @returns {import('react').ReactNode}
 */
const ProductLabel = ({ className, label, swatchLabel, index = 0, isCheckbox = false, isCustomLabel = false, hideSize = false, hideQuantity = true, showSurplusSaleLabel = false, toggleType, toggleLabel, toggleContent, toggleClickHandler, toggleModalHeader, modalContentProps }) => {
    const labelClassName = (0, classnames_1.default)(ProductLabel_module_scss_1.default.productLabel, {
        [ProductLabel_module_scss_1.default['productLabel-swatch']]: swatchLabel,
        [ProductLabel_module_scss_1.default['productLabel-hasQuantity']]: index === 0 && !hideQuantity,
        'u-hidden': hideSize && label.toLowerCase().includes('size')
    }, className);
    const onSaleClassName = (0, classnames_1.default)('t-heading5', ProductLabel_module_scss_1.default['productLabel-onSale']);
    const toggleClassName = (0, classnames_1.default)('t-link t-link--independent t-link--action', ProductLabel_module_scss_1.default['productLabel-toggle']);
    const swatchClassName = (0, classnames_1.default)('t-body u-marginLeft', ProductLabel_module_scss_1.default['productLabel-swatch']);
    const labelText = getLabel(label, isCustomLabel);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showSurplusSaleLabel &&
                (0, jsx_runtime_1.jsx)("p", { className: onSaleClassName, children: "Select styles on sale" }), (0, jsx_runtime_1.jsxs)("span", { "data-style-selector": 'productLabel', className: labelClassName, children: [!isCheckbox && labelText, toggleType === 'link' &&
                        (0, jsx_runtime_1.jsx)(react_scroll_1.Link, { className: toggleClassName, to: toggleContent, tabIndex: "0", smooth: true, duration: 900, offset: floatingProductPanelOffset, onClick: toggleClickHandler, children: toggleLabel }), toggleType === 'anchor' &&
                        (0, jsx_runtime_1.jsx)("a", { className: toggleClassName, href: toggleContent, onClick: toggleClickHandler, children: toggleLabel }), toggleType === 'modal' &&
                        (0, jsx_runtime_1.jsx)(ModalToggle, { className: toggleClassName, text: toggleLabel, header: toggleModalHeader, content: toggleContent, contentProps: modalContentProps, onClick: toggleClickHandler }), swatchLabel && !isCheckbox &&
                        (0, jsx_runtime_1.jsx)("span", { "data-style-selector": 'productLabel__swatch', className: swatchClassName, children: swatchLabel })] })] }));
};
ProductLabel.propTypes = {
    className: prop_types_1.default.string,
    label: prop_types_1.default.string,
    swatchLabel: prop_types_1.default.string,
    index: prop_types_1.default.number,
    isCheckbox: prop_types_1.default.bool,
    isCustomLabel: prop_types_1.default.bool,
    hideSize: prop_types_1.default.bool,
    hideQuantity: prop_types_1.default.bool,
    showSurplusSaleLabel: prop_types_1.default.bool,
    toggleType: prop_types_1.default.oneOf(['modal', 'link', 'anchor']),
    toggleLabel: prop_types_1.default.string,
    toggleContent: prop_types_1.default.any,
    toggleClickHandler: prop_types_1.default.func,
    toggleModalHeader: prop_types_1.default.string,
    modalContentProps: prop_types_1.default.object
};
exports.default = ProductLabel;
//# sourceMappingURL=ProductLabel.js.map